import { DataTableValidators } from 'src/app/shared/data-table/validators';
import { CgpConfirmationDialogService } from './../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { BuildDesignWeightAddModalComponent } from './build-design-weight-add-modal/build-design-weight-add-modal.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataTableComponent } from './../../../../shared/data-table/data-table.component';
import { BuildDesignWeightModalService } from './build-design-weight-modal.service';
import { DataTableService } from './../../../../shared/data-table/data-table.service';
import { PageOptions, ColumnDef } from './../../../../shared/data-table/data-table.interface';
import { Component, ViewChild, OnInit } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { filter, finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'build-design-weight-modal',
  templateUrl: './build-design-weight-modal.component.html'
})
export class BuildDesignWeightModalComponent implements OnInit {

  loading = true;

  buildDesignWeights: any[];

  page: PageOptions = this.dataTableService.pageOptionsDefaultSort('id');
  total = 0;

  @ViewChild('data', { static: true }) dataTable: DataTableComponent;

  columns: ColumnDef[] = this.buildDesignWeightService.getBuildDesignWeightFields()
    .map(column => ({
      field: column.field,
      name: column.name,
      validators: DataTableValidators.numeric(false, (msg: string) => this.toastr.error(msg))
    }));

  constructor(
    private readonly buildDesignWeightService: BuildDesignWeightModalService,
    private readonly dataTableService: DataTableService,
    private readonly dialog: MatDialog,
    private readonly confirmation: CgpConfirmationDialogService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadBuildDesignWeights();
  }

  loadBuildDesignWeights() {
    this.loading = true;
    this.dataTable.selected = null;

    this.buildDesignWeightService.getBuildDesignWeights(this.page)
      .subscribe((response) => {
        this.buildDesignWeights = response.data;
        this.total = response.totalCount;

        this.loading = false;
      });
  }

  onLazyLoad(event: LazyLoadEvent) {

    this.loading = true;

    this.page.order = event.sortOrder === 1 ? 'asc' : 'desc';
    this.page.size = event.rows;
    this.page.sort = event.sortField;
    this.page.page = event.first / this.page.size;

    this.loadBuildDesignWeights();
  }

  addBuildDesignWeight() {
    this.dialog.open(BuildDesignWeightAddModalComponent, { width: '54vw', height: '54vh' })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => this.loadBuildDesignWeights());
  }

  deleteBuildDesignWeight() {
    const id = (this.dataTable.selected || {}).id;

    if (id) {
      this.confirmation.showConfirmationDialog({
        message: 'Do you want to delete this build design weight?',
        onYesClick: () => {
          this.buildDesignWeightService.deleteBuildDesignWeight(id)
            .subscribe(() => this.loadBuildDesignWeights());
          this.confirmation.closeConfirmationDialog();
          this.dataTable.selected = undefined;
        },
        onNoClick: () => this.confirmation.closeConfirmationDialog()
      });
    } else {
      this.toastr.error('Please select a build design weight to delete');
    }
  }

  editBuildDesignWeight(event: any) {
    this.loading = true;

    this.buildDesignWeightService.updateBuildDesignWeight(event.data)
      .subscribe(
        (result: any) => {
          this.buildDesignWeights[this.buildDesignWeights.findIndex(weight => weight.id === result.id)] = result;
          this.loading = false;
        },
        (err: any) => this.loadBuildDesignWeights()
      );
  }
}
